import { AsButton, AsText, Spacer } from '@adserve/adserve-react-components';
import React, { useEffect, useRef } from 'react';
import {
    applyButtonStyle,
    monthlyPoListContainerStyle,
    monthlyPoListNumberCellStyle,
    monthlyPoListPeriodCellStyle,
    monthlyPoListTableStyle,
    monthlyPoListTextStyle,
    monthlyPoListTitleStyle,
    monthlyPoNumberInlineStyle
} from './CampaignBriefStyles';
import { ReactComponent as IconClose } from '../../../svg/icon_close.svg';
import ScrollableContent from '../../Scrolling/ScrollableContent';
import { createPortal } from 'react-dom';

const MonthlyPoList = ({ campaign, setShowing, readOnly, handlePoMonthlyChange, showing = false, boundingRect, onClickOutside }) => {
    const ref = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                onClickOutside(event);
            }
        };
        if (showing) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref, showing]);
    const handleNumberChange = (event, idx) => {
        const value = event.target.value;
        handlePoMonthlyChange(value, idx);
    };

    const handleApplyClick = () => {
        campaign.poNumbersJson.usingSingle = false;
        setShowing(false);
    };

    return showing
        ? createPortal(
            <div
                ref={ref}
                style={{
                    ...monthlyPoListContainerStyle,
                    position: 'absolute',
                    top: boundingRect.top + boundingRect.height + window.scrollY,
                    left: boundingRect.left + window.scrollX
                }}
            >
                <div style={{ marginTop: 10, textAlign: 'center' }}>
                    <span style={monthlyPoListTitleStyle}>Monthly PO Numbers</span>
                </div>

                <div
                    onClick={onClickOutside}
                    style={{
                        position: 'absolute',
                        marginLeft: 240,
                        marginTop: -36
                    }}
                >
                    <IconClose style={{ cursor: 'pointer' }} fill={'#414141'} size={21} />
                </div>

                <div style={{ display: 'flex', marginTop: 12 }}>
                    <Spacer height={0} width={11} />
                    <span style={monthlyPoListTextStyle}>Months</span>
                    <Spacer height={0} width={70} />
                    <span style={monthlyPoListTextStyle}>PO Number</span>
                </div>

                <div
                    style={{
                        width: 247,
                        marginLeft: 9,
                        height: 210,
                        overflow: 'hidden'
                    }}
                >
                    <ScrollableContent style={{ height: 205 }}>
                        <table style={monthlyPoListTableStyle}>
                            <tbody>
                                {campaign?.poNumbersJson?.multiple?.map((pn, i) => (
                                    <tr key={`poNumber${i}`}>
                                        <td style={monthlyPoListPeriodCellStyle(i)}>
                                            <span style={monthlyPoListTextStyle}>{pn?.dateText}</span>
                                        </td>
                                        <td style={monthlyPoListNumberCellStyle(i)}>
                                            <AsText
                                                id={`campaign-monthly-po-number-${i}`}
                                                name='monthlyPoNumber'
                                                inputStyle={monthlyPoNumberInlineStyle}
                                                onChange={(e) => handleNumberChange(e, i)}
                                                value={pn?.poNumber}
                                                disabled={readOnly}
                                            />
                                        </td>
                                    </tr>
                                ))}
                                {campaign?.poNumbersJson?.multiple?.length < 6 &&
                                      Array.apply(
                                          null,
                                          Array(
                                              6 -
                                                  (campaign?.poNumbersJson
                                                      ? campaign?.poNumbersJson?.multiple?.length
                                                      : 0)
                                          )
                                      )
                                          .map(function () {
                                              return {};
                                          })
                                          .map((r, j) => (
                                              <tr key={`emptyPoRow${j}`}>
                                                  <td style={monthlyPoListPeriodCellStyle(j)}>{''}</td>
                                                  <td style={monthlyPoListNumberCellStyle(j)}>{''}</td>
                                              </tr>
                                          ))}
                            </tbody>
                        </table>
                    </ScrollableContent>
                </div>

                <div style={{ marginTop: 10, display: 'flex', justifyContent: 'center' }}>
                    <AsButton handleClick={handleApplyClick} style={applyButtonStyle}>
                          Apply
                    </AsButton>
                </div>
            </div>,
            document.body
        )
        : null;
};

export default MonthlyPoList;
